// Libs
import React from 'react';
import { Box, Typography, Grid } from '@mui/material';

// Components
import AddressesTruncatedLabel from '../../../Labels/AddressesTruncatedLabel';

const ADDRESS_STRINGS_QTY = 2;

const OrderCardShippingAddress = ({
  order,
  isMobileMode,
  isTabletMode,
  gridPropValues,
  classes,
}) => (
  <Grid
    item
    flexBasis={gridPropValues({
      lgSize: 5,
      mdSize: 12,
      unit: '%',
    })}
    maxWidth={gridPropValues({
      lgSize: 5,
      mdSize: 12,
      unit: '%',
    })}
    order={gridPropValues({
      lgSize: 5,
      mdSize: 4,
    })}
    paddingRight={isMobileMode ? '10px' : 0}>
    <Box display="flex" flexDirection="column" data-testid="shipping-address">
      <Typography className={classes.headerText}>Shipping Address:</Typography>
      <AddressesTruncatedLabel
        stringsQty={isTabletMode && isMobileMode ? 1 : ADDRESS_STRINGS_QTY}
        order={order}
        className={classes.text}
      />
    </Box>
  </Grid>
);

export default OrderCardShippingAddress;
